module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Shopping/Sale1-e0fb4c7ee20c6a45db153eda4891e62c.svg";